import { BaseService } from "../../core/baseService";
import {
  UnifiedRequestsServiceInterface,
  GetUnifiedRequestsParams,
  UnifiedRequestDto,
} from "../types/unifiedRequests.types";
import { PaginatedResponse } from "../../../models";
import { ApiResult } from "../../core/types";

export class UnifiedRequestsService
  extends BaseService
  implements UnifiedRequestsServiceInterface
{
  async getRequests(
    params: GetUnifiedRequestsParams,
  ): Promise<ApiResult<PaginatedResponse<UnifiedRequestDto>>> {
    const queryParams = this.buildQueryParams({
      pageNumber: params.page,
      pageSize: params.pageSize,
      requestType: params.requestType ?? undefined,
      status: params.status,
      roomNumber: params.roomFilter,
      includeClosed: params.includeClosed,
    });

    return this.handleRequest<PaginatedResponse<UnifiedRequestDto>>(
      this.client.get("/api/admin/unified-requests", {
        params: queryParams,
      }),
    );
  }
}
